import { memo } from "react";

const DestinationsDDL = ({ destRef, label, destinations, onChange }) => {
    console.log('DestinationsDDL rendered');
    console.log(destRef)
    return <select ref={destRef} className="form-select" onChange={onChange}>
        <option value="" data-name={null} data-ec={false} data-branch={null}>Select {label}</option>
        {
            destinations.map((x, index) => <option key={index} value={x.value} data-ec={x.isExpressCargo} data-name={x.text} data-branch={x.branchCode}>{x.text}</option>)
        }
    </select>
}

const MemoDestinationsDDL = memo(DestinationsDDL, (prv, nxt) => {
    return prv.destinations === nxt.destinations
});


export default MemoDestinationsDDL;